<template>
  <header class="header">
    <div class="header__container">
      <div class="header__container__logo">
        <img :src="headerIcon" alt="Logo" />
      </div>
      <div
        role="button"
        class="header__container__button"
        :class="{ disabled: !isFromMexico && !getIsGSUser }"
        @click="onClickOpenModes()"
      >
        {{ stringButtonText }}
      </div>
      <div class="header__container__options" :class="{ 'is-disabled': isOptionsDisabled }" @click="onClickOptions">
        <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn-menu-options.png" alt="options" />
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'MediaPlayerHeader',
  props: {
    headerIcon: {
      type: String,
      default: '',
    },
    isOptionsDisabled: {
      type: Boolean,
      default: false,
    },
    isFromMexico: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['windowWidth']),
    ...mapGetters('loginGeneral', ['getIsGSUser']),
    stringButtonText() {
      return this.windowWidth > 495 ? 'Haz click aquí para elegir lo que deseas ver' : 'Haz click aquí para elegir';
    },
  },
  methods: {
    onClickOpenModes() {
      if (this.isFromMexico || this.getIsGSUser) {
        this.$emit('click-open-modes');
      }
    },
    onClickOptions(/*$event*/) {
      if (!this.isOptionsDisabled) {
        this.$emit(
          'click-options' /*{
          numberX: $event.target.x + $event.target.width,
          numberY: $event.target.y + $event.target.height + 10,
        }*/,
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
$blue: #132739;
$green: #cbee6b;

.header {
  width: 100%;
  font-size: 1rem;

  &__container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: $blue;
    border-bottom: solid 3px $green;
    min-height: 2.6em;

    &__logo {
      position: absolute;
      left: 0.5em;
      height: 2em;
      margin-left: 8px;

      & > img {
        width: 28px;
        height: auto;
      }
    }

    &__button {
      font-family: Roboto-Regular, sans-serif;
      font-size: 0.875em;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.83;
      letter-spacing: -0.14px;
      text-align: center;
      color: #132839;
      border-radius: 18px;
      border: solid 1px #f8f040;
      background-color: #f8f040;
      padding: 8px 28px;
      cursor: pointer;
    }

    &__options {
      position: absolute;
      right: 8px;
      height: 24px;
      width: 24px;
      cursor: pointer;

      &.is-disabled {
        opacity: 0.5;
        cursor: default;
      }

      & > img {
        height: 24px;
        width: 24px;
      }
    }
  }

  @media screen and (max-width: 462px) {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    &__container {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      justify-content: left;
      padding: 0 8px;

      &__logo {
        display: none;
      }
    }
  }
}

.disabled {
  cursor: default;
  opacity: 0.6;
}
</style>
